<app-header/>
<app-slider id="home" [slides]="homePageSlides"/>

<!-- Start about Area -->
<section class="about" id="about">
  <div class="about-title">
    <h2>{{ "Why Travel With Us" | translate }}</h2>
    <p>{{ "We are a travel agency" | translate }}</p>
  </div>
  <div class="about-content">
    <div class="leftSide">
      <img src="../../../assets/img/garni2.jpg" alt="Temple of Garni">
    </div>
    <div class="rightSide">
      <div class="texts">
        <h2>{{ "Our Mission" | translate }}</h2>
        <p>{{ "About Us text" | translate }}</p>
        <h3>{{ "Tour Count" | translate }}</h3>
      </div>
    </div>
  </div>
</section>
<!-- End about Area -->


<app-tours id="tours"/>

<!-- Start feature Area -->
<section class="service" id="service">
  <div class="title">
    <h2>{{ "Some Features that Made us Unique" | translate }}</h2>
    <p>{{ "We are a travel agency" | translate }}</p>
  </div>
  <div class="service-box">
    <div class="service-box-item">

      <div class="icon-title">
        <i class="ph ph-map-trifold"></i>
        <h2>{{ "feature_1" | translate }}</h2>
      </div>

      <div class="description">
        <p>{{ "feature_1_desc" | translate }}</p>
      </div>
    </div>

    <div class="service-box-item">
      <div class="icon-title">
        <i class="ph ph-car"></i>
        <h2>{{ "feature_2" | translate }}</h2>
      </div>

      <div class="description">
        <p>{{ "feature_2_desc" | translate }}</p>
      </div>
    </div>

    <div class="service-box-item">
      <div class="icon-title">
        <i class="ph ph-calendar-check"></i>
        <h2>{{ "feature_3" | translate }}</h2>
      </div>
      <div class="description">
        <p>{{ "feature_3_desc" | translate }}</p>
      </div>
    </div>

    <div class="service-box-item">
      <div class="icon-title">
        <i class="ph ph-signpost"></i>
        <h2>{{ "feature_4" | translate }}</h2>
      </div>
      <div class="description">
        <p>{{ "feature_4_desc" | translate }}</p>
      </div>
    </div>

    <div class="service-box-item">
      <div class="icon-title">
        <i class="ph ph-map-pin"></i>
        <h2>{{ "feature_5" | translate }}</h2>
      </div>
      <div class="description">
        <p>{{ "feature_5_desc" | translate }}</p>
      </div>
    </div>

    <div class="service-box-item">
      <div class="icon-title">
        <i class="ph ph-headset"></i>
        <h2>{{ "feature_6" | translate }}</h2>
      </div>
      <div class="description">
        <p>{{ "feature_6_desc" | translate }}</p>
      </div>
    </div>
  </div>
</section>
<!-- End feature Area -->

<!-- Start faq Area -->
<app-faq id="faq"/>
<!-- End faq Area -->

<!-- Start Video Area -->
<app-video/>
<!-- Start Video Area -->

<!-- start contact Area -->
<app-contact id="contact"/>
<!-- end contact Area -->
